import { type EligibilitySource, EligibilitySummaryContent } from '@features/eligibility-checks';
import { CoverageEligibilityWorkspace } from '@features/eligibility-checks/components/CoverageEligibilityWorkspace';
import { Button } from '@mui/material';

interface Props {
  patientId: string;
  encounterId?: string;
  patientName?: string | null;
  source?: EligibilitySource | (string & {});
  /** Open the manual benefits dialog on mount (worklist row click for blocked/attention). */
  initialForm?: 'verification';
  /** Flip to Ledger tab + open settle sheet pre-targeted to method=external. */
  onLogCollection: () => void;
  canRunCheck?: boolean;
  canLogCollection?: boolean;
}

export const EligibilityTabContent = (props: Props) => {
  return (
    <CoverageEligibilityWorkspace
      initialManualEntry={props.initialForm === 'verification'}
      key={props.patientId}
      patientId={props.patientId}
      encounterId={props.encounterId}
      canRunCheck={props.canRunCheck ?? true}
      collectionAction={
        (props.canLogCollection ?? true) && (
          <Button onClick={props.onLogCollection}>Log collection</Button>
        )
      }
      contextContent={(collectionAction, checkActions) => (
        <>
          <EligibilitySummaryContent
            patientId={props.patientId}
            encounterId={props.encounterId}
            patientName={props.patientName ?? undefined}
            source={props.source as EligibilitySource}
            showRerun={false}
            hidePrimaryAction={!!checkActions}
            hideSecondaryAction
            hideProvenance
            compact
            additionalAction={
              <>
                {checkActions}
                {collectionAction}
              </>
            }
          />
        </>
      )}
    />
  );
};
